import { UpdateBusinessAccountRepresentativeDetailsArgs } from 'types/api/arguments/update-business-account-representative-details-args'

import { api } from './api'

export const updateBusinessAccountRepresentativeDetails = ({
  identityDocumentExpirationDate,
  email,
}: UpdateBusinessAccountRepresentativeDetailsArgs) =>
  api.put('/business_accounts_dsa/representatives', {
    identity_document_expiration_date: identityDocumentExpirationDate,
    email,
  })
